import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BasketView } from 'ish-core/models/basket/basket.model';
import { PaymentMethod } from 'ish-core/models/payment-method/payment-method.model';
import { PriceItemHelper } from 'ish-core/models/price-item/price-item.helper';
import { PriceType } from 'ish-core/models/price/price.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';

/**
 * Component for displaying payment costs and payment restriction information.
 */
@Component({
  selector: 'ish-basket-payment-cost-info',
  templateUrl: './basket-payment-cost-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PricePipe, TranslateModule],
})
export class BasketPaymentCostInfoComponent {
  readonly paymentMethod = input.required<PaymentMethod>();
  readonly basket = input.required<BasketView>();
  readonly priceType = input.required<PriceType>();

  /**
   * Determine whether payment cost threshold has been reached
   * for usage in template
   */
  paymentCostThresholdReached(paymentMethod: PaymentMethod): boolean {
    const basketTotalPrice = PriceItemHelper.selectType(this.basket().totals.total, this.priceType());

    if (paymentMethod.paymentCostsThreshold && basketTotalPrice) {
      return (
        PriceItemHelper.selectType(paymentMethod.paymentCostsThreshold, this.priceType())?.value <=
        basketTotalPrice.value
      );
    }
    return false;
  }
}
